// react-router-dom components
import { Link, useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import MuiBreadcrumbs from "@mui/material/Breadcrumbs";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import { removeSingleParam } from "helpers/RemoveSingleUrlParam";
import { useSelector } from "react-redux";

function Breadcrumbs({ icon, title, route, light = false }) {
  const routes = route.slice(0, -1);
  const { pathname } = useLocation();
  const removedIdRoute = removeSingleParam(pathname);
  const { customerSubscription } = useSelector((store) => store.portal.subscriptions);

  return (
    <SoftBox ml={{ xs: 0, xl: 2, md: 2 }} mr={{ xs: 2, xl: 0, md: 0 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        <Link to={!customerSubscription ? "#" : "/home"}>
          <SoftTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </SoftTypography>
        </Link>
        {routes.map((el) => {
          // <Link to={`/${el}`} key={el}>
          return (
            <SoftTypography
              key={el}
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {el}
            </SoftTypography>
          );
          // </Link>
        })}
        {removedIdRoute === "/account/users/profile-overview" ||
        removedIdRoute === "/account/users/user-edit" ||
        removedIdRoute === "/administration/roles-and-permissions" ? (
          ""
        ) : (
          <SoftTypography
            variant="button"
            fontWeight="regular"
            textTransform="capitalize"
            color={light ? "white" : "dark"}
            sx={{ lineHeight: 0 }}
          >
            {title.replace(/-/gi, " ")}
          </SoftTypography>
        )}
      </MuiBreadcrumbs>
    </SoftBox>
  );
}

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
